import { Controller } from 'stimulus'
let debounce = require('lodash/debounce')

export default class extends Controller {
  static targets = ['output', 'form', "addonForm", "participantCount"]
  static values = { 
    themeName: String, 
    host: Boolean, 
    currency: String, 
    price: String, 
    participants: Number, 
    startDate: String,
    isEditing: Boolean
  }

  connect() {
    window.feather.replace()
    window.tippy('[data-tippy-content]')

    this.submit = debounce(this.submit, 1000)
  }

  markAsPending(e) {
    const participantCount = parseInt($(this.participantCountTarget).val())
    if (participantCount > 0) {
      this.clearHighlightParticipantsEmpty()
    } else {
      this.highlightParticipantsEmpty()
    }
    this.nilOutputs(e)
    this.validateInputs(e)
  }

  nilOutputs() {
    this.outputTargets.forEach(function (item) {
      item.innerHTML = '...'
    })
  }

  focusOnParticipants(e) {
    this.highlightParticipantsEmpty()
    this.participantCountTarget.select()
  }

  highlightParticipantsEmpty() {
    $(this.participantCountTarget).parent().addClass('border-red-500').removeClass('border-transparent')
  }

  clearHighlightParticipantsEmpty() {
    $(this.participantCountTarget).parent().removeClass('border-red-500').addClass('border-transparent')
  }

  increaseParticipants(e) {
    var currentCount = parseInt($(this.participantCountTarget).val())
    $(this.participantCountTarget).val(currentCount + 1)
    this.markAsPending($(this.participantCountTarget))
    this.submit($(this.participantCountTarget))

    mixpanel.track('Increased Participants', {
      'themeName': this.themeNameValue,
      'host': this.hostValue,
      'currency': this.currencyValue,
      'price': this.priceValue,
      'participants': parseInt($(this.participantCountTarget).val()),
      'date': new Date(this.startDateValue).toISOString(),
      'isEditing': this.isEditingValue
    });
  }

  decreaseParticipants(e) {
    var currentCount = parseInt($(this.participantCountTarget).val())
    $(this.participantCountTarget).val(currentCount - 1)
    this.markAsPending($(this.participantCountTarget))
    this.submit($(this.participantCountTarget))

    mixpanel.track('Decreased Participants', {
      'themeName': this.themeNameValue,
      'host': this.hostValue,
      'currency': this.currencyValue,
      'price': this.priceValue,
      'participants': parseInt($(this.participantCountTarget).val()),
      'date': new Date(this.startDateValue).toISOString(),
      'isEditing': this.isEditingValue
    });
  }

  validateInputs(e) {
    let input = e.target
    if (e.target == undefined) {
      input = e[0]
    }

    var min = input.getAttribute('min')
    if (!!min && input.value && input.value < parseFloat(min)) {
      input.value = min
    }
  }

  cancel() {
    this.submit.cancel()
  }

  submitWithoutPendingState(e) {
    this.formTarget.requestSubmit()
  }

  submitAddonWithoutPendingState(e) {
    // Prevent toggling when clicking on the dropdown or its contents
    if (e.target.closest('[data-action*="dropdown#toggle"]') || 
        e.target.closest('[data-dropdown-target="menu"]')) {
      return
    }

    e.preventDefault()
    this.addonFormTarget.requestSubmit()
  }

  submit(e) {
    this.markAsPending(e)
    this.formTarget.requestSubmit()
  }

  openDateModal(e) {
    e.preventDefault()
    window.dispatchEvent(new CustomEvent("openDateModal", {
      detail: {
        type: e.currentTarget.dataset.type
      }
    }))
  }

  openDeliveryTypesModal(e) {
    e.preventDefault()
    window.dispatchEvent(new CustomEvent("openDeliveryTypesModal", {
      detail: {
        type: e.currentTarget.dataset.type
      }
    }))
  }

  openDeliveryTypesModalNext(e) {
    window.dispatchEvent(new CustomEvent("openDeliveryTypesModal", {
      detail: {
        type: e.currentTarget.dataset.type
      }
    }))
  }

  deliveryTypeProceed(e) {
    const $elem = $('[data-variant-count]').first()
    const variantCount = Number($elem.data('variant-count'))
    if (variantCount > 1) {
      this.openVariantsModal(e)
    } else {
      const isGpsEvent = !!Number($elem.data('gps-event'))
      if (isGpsEvent) {
        this.openRegionsModal(e)
      } else {
        this.openSupportModal(e)
      }
    }
  }

  openVariantsModal(e) {
    e.preventDefault()
    window.dispatchEvent(new CustomEvent("openVariantsModal", {
      detail: {
        type: e.currentTarget.dataset.type
      }
    }))
  }

  openVariantsModalNext(e) {
    window.dispatchEvent(new CustomEvent("openVariantsModal", {
      detail: {
        type: e.currentTarget.dataset.type
      }
    }))
  }

  openRegionsModal(e) {
    e.preventDefault()
    window.dispatchEvent(new CustomEvent("openRegionsModal", {
      detail: {
        type: e.currentTarget.dataset.type
      }
    }))
  }

  openSupportModal(e) {
    if ($(e.target).hasClass("disabled")) return

    e.preventDefault()
    window.dispatchEvent(new CustomEvent("openSupportModal", {
      detail: {
        type: e.currentTarget.dataset.type
      }
    }))
  }
  
  openAddonsModal(e) {
    e.preventDefault()
    window.dispatchEvent(new CustomEvent("openAddonsModal", {
      detail: {
        type: e.currentTarget.dataset.type
      }
    }))
  }

  openShareModal(e) {
    e.preventDefault()
    window.dispatchEvent(new CustomEvent("openShareModal"))
  }

  switchCurrency(e) {
    const $selector = $(e.currentTarget)
    const url = $('option:selected', $selector).data('url')
    return window.location.href = url
  }


  proceedToPayment(e) {
    mixpanel.track('Clicked Proceed To Payment', {
      'themeName': this.themeNameValue,
      'host': this.hostValue,
      'currency': this.currencyValue,
      'price': this.priceValue,
      'participants': parseInt($(this.participantCountTarget).val()),
      'date': new Date(this.startDateValue).toISOString(),
      'isEditing': this.isEditingValue
    }, {send_immediately: true});
  }
}
